import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import AllOrg from '@/modules/organisations/all-org';
import { useState } from 'react';
import { useAuthStore } from '@/store/auth';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Heading } from '@/components/ui/heading';
import PageContainer from '@/components/layout/page-container';

type OrganizationViewPageProps = {};

export default function OrganizationViewPage({}: OrganizationViewPageProps) {
  const context = useAuthStore((state) => state.context);
  const [allOrg, setAllOrg] = useState(0);
  const isWorkspaceUser = context === 'workspace';

  return (
    <PageContainer scrollable={true}> 
      <div className='mb-5 flex items-center justify-between px-4'>
        <Heading title='Organisations' description={''} />
        {isWorkspaceUser && (
          <Link to={`/dashboard/organisations/add`} >
            <Button id='add-organisations'>Add Organisations</Button>
          </Link>
        )}
      </div>
      <Tabs defaultValue='all' className='h-full space-y-4 bg-white py-3'>
        <TabsList className='w-full border-b px-5'>
          <TabsTrigger onClick={() => {}} value='all'>
            All Organisations {allOrg}
          </TabsTrigger>
        </TabsList>
        <TabsContent value='all' className='h-full space-y-4'>
          <AllOrg onCountUpdate={setAllOrg} />
        </TabsContent>
      </Tabs>
    </PageContainer>
  );
}
